module.exports = __webpack_public_path__ + "static/media/card-project2.93b1cec5.jpg";